import { render, staticRenderFns } from "./OttFooterWidget.vue?vue&type=template&id=60ed3674"
import script from "./OttFooterWidget.vue?vue&type=script&lang=js"
export * from "./OttFooterWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports